import * as React from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";

import PlainCopy from "components/icons/PlainCopy";
import style from "components/licenses/license-keys-table.scss";
import Tooltip from "components/tooltip/Tooltip";

import testIds from "testIds.json";

export function ShortUrlTableCell(props: { shortUrl: string }): JSX.Element {
    const { t } = useTranslation();
    const [copied, setCopied] = React.useState(false);
    const [showTooltip, setShowTooltip] = React.useState(false);
    const [position, setPosition] = React.useState("0px");
    const [renderQrTooltip, setRenderQrTooltip] = React.useState(false);
    const copyToClipboard = (url: string) => {
        navigator.clipboard.writeText(url).then(() => setCopied(true));
    };
    // This value is not necessarily randomly picked. This one is most suitable
    // for setting a good position for the tooltip.
    const OFFSET = 55;

    return (
        <>
            <span hidden={!showTooltip} className={style.tooltip} style={{ top: position }}>
                {copied ? t("Common.copied") : t("Common.copyToClipboard")}
            </span>
            <div className={style.shortUrlCell} onMouseLeave={() => setCopied(false)}>
                <a
                    className={style.shortUrl}
                    href={props.shortUrl}
                    target={"blank"}
                    onMouseOver={() => {
                        setRenderQrTooltip(true);
                    }}
                    onMouseLeave={() => setRenderQrTooltip(false)}
                >
                    {renderQrTooltip ? (
                        <Tooltip content={<QRCode value={props.shortUrl} size={100} />}>
                            <a>{props.shortUrl}</a>
                        </Tooltip>
                    ) : (
                        <a>{props.shortUrl}</a>
                    )}
                </a>
                <button
                    className={style.copyIcon}
                    onClick={() => {
                        copyToClipboard(props.shortUrl);
                    }}
                    data-testid={testIds.workArea.license.bms.table.copyUrlButton}
                    onMouseOver={(event) => {
                        setShowTooltip(true);
                        setPosition((event.nativeEvent.clientY - OFFSET).toString() + "px");
                    }}
                    onMouseLeave={() => setShowTooltip(false)}
                    hidden={props.shortUrl == null}
                >
                    <PlainCopy />
                </button>
            </div>
        </>
    );
}
